var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#181822"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11234_31152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.075 13.1918C14.326 13.4421 14.326 13.8482 14.075 14.0985C13.8241 14.3489 13.4168 14.3488 13.1658 14.0985L10.0005 10.9183L6.81268 14.0975C6.5617 14.3478 6.15448 14.3478 5.90348 14.0975C5.65247 13.8472 5.65249 13.4411 5.90348 13.1907L9.09238 10.0126L5.90259 6.80932C5.65161 6.55902 5.65161 6.15291 5.90259 5.90258C6.15357 5.65225 6.56078 5.65228 6.81179 5.90258L10.0005 9.10691L13.1883 5.92769C13.4393 5.67739 13.8465 5.67739 14.0975 5.92769C14.3485 6.178 14.3485 6.58411 14.0975 6.83444L10.9086 10.0126L14.075 13.1918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11234_31152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackX);
export default __webpack_public_path__ + "static/media/black-x.04f38f040123b2d6638f7f279e4b4b1a.svg";
export { ForwardRef as ReactComponent };